import React, { useMemo } from 'react';
import { Button, Icon } from 'semantic-ui-react';

const CustomPagination = ({ totalCount, page, setPage, size, setSize }) => {
  const numberOfPages = useMemo(
    () => Math.ceil(totalCount / size),
    [size, totalCount]
  );
  return (
    <div className='flex items-center justify-end px-2 py-4 bg-white border border-gray-300'>
      <label>
        Rows Per Page:
        <select
          value={size}
          onChange={(e) => {
            setSize(e.target.value);
            setPage(0);
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </label>
      <div className='flex items-center ml-6 justify-evenly'>
        <Button
          onClick={() => {
            setPage(0);
          }}
          disabled={page === 0}
          basic
          size='mini'
          icon
        >
          <Icon name='angle double left' />
        </Button>
        <Button
          className='px-2 py-1'
          basic
          disabled={page === 0}
          onClick={() => {
            setPage((current) => current - 1);
          }}
          size='mini'
          icon
        >
          <Icon name='angle left' />
        </Button>
        <p className='mx-4'>
          {page + 1} of{' '}
          {numberOfPages === 0 ? numberOfPages + 1 : numberOfPages}
        </p>
        <Button
          className='px-2 py-1'
          basic
          disabled={page === numberOfPages - 1 || numberOfPages === 0}
          onClick={() => {
            setPage((current) => current + 1);
          }}
          size='mini'
          icon
        >
          <Icon name='angle right' />
        </Button>
        <Button
          onClick={() => {
            setPage(numberOfPages - 1);
          }}
          disabled={page === numberOfPages - 1 || numberOfPages === 0}
          basic
          size='mini'
          icon
        >
          <Icon name='angle double right' />
        </Button>
      </div>
    </div>
  );
};

export default CustomPagination;
